import defaultAttributes from '../defaultAttributes';

const PieChart = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M21.21 15.89A10 10 0 118 2.83' }],
    ['path', { d: 'M22 12A10 10 0 0012 2v10z' }],
  ],
];

export default PieChart;
